import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";

export const getNewsFn = () => {
    const response = protectedApi.get(`${ENDPOINTS.news_api}`);
    return response;
}

export const getNewsByIdFn = (id) => {
    const response = protectedApi.get(`${ENDPOINTS.news_api}?news_id=${id}`);
    return response;
}

export const postNewsFn = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.news_api}`, reqBody);
    return response;
}

export const patchNewsFn = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.news_api}`, reqBody);
    return response;
}

export const deleteNewsFn = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.news_api}`, { data: reqBody });
    return response;
}
